import React from "react";
import PropTypes from "prop-types";
import { CELL_TYPE } from "../DialysisDragDrop.constants";
import { DialysisDragDropContext } from "../DialysisDragDrop.utils";
import { getStyle } from "../DialysisBand/DialysisBand.utils";

import Icon1 from "./icons/Icon1.svg";
import Icon2 from "./icons/Icon2.svg";
import Icon3 from "./icons/Icon3.svg";

export function ScaleColumn(props) {
  const { state, getGridTemplateRows } = React.useContext(
    DialysisDragDropContext
  );

  const getClassName = (cellType) => {
    return `${props.className}__${cellType.toLowerCase()}`;
  };

  const renderScale = (ticks) => {
    return (
      <div className="scale">
        <div className="icons">
          <img className="Icon1" src={Icon1} alt="" />
          <div className="icons_center">
            <img className="Icon2" src={Icon2} alt="" />
          </div>
          <img className="Icon3" src={Icon3} alt="" />
        </div>
        {ticks}
      </div>
    );
  };

  const renderScaleTicks = (scaleTick, index, total) => {
    const TickStyle = getStyle({ state, props: scaleTick });
    return (
      <>
        <div className="tickScales" style={TickStyle}></div>
        {index !== total - 1 ? (
          <>
            <div
              className="tickScales sub"
              style={getStyle({
                state,
                props: { ...scaleTick, value: scaleTick.value - 0.1 },
              })}
            ></div>
            <div
              className="tickScales sub"
              style={getStyle({
                state,
                props: { ...scaleTick, value: scaleTick.value - 0.2 },
              })}
            ></div>
            <div
              className="tickScales sub"
              style={getStyle({
                state,
                props: { ...scaleTick, value: scaleTick.value - 0.3 },
              })}
            ></div>
            <div
              className="tickScales sub"
              style={getStyle({
                state,
                props: { ...scaleTick, value: scaleTick.value - 0.4 },
              })}
            ></div>
            <div
              className="tickScales mid-sub"
              style={getStyle({
                state,
                props: { ...scaleTick, value: scaleTick.value - 0.5 },
              })}
            ></div>
            <div
              className="tickScales sub"
              style={getStyle({
                state,
                props: { ...scaleTick, value: scaleTick.value - 0.6 },
              })}
            ></div>
            <div
              className="tickScales sub"
              style={getStyle({
                state,
                props: { ...scaleTick, value: scaleTick.value - 0.7 },
              })}
            ></div>
            <div
              className="tickScales sub"
              style={getStyle({
                state,
                props: { ...scaleTick, value: scaleTick.value - 0.8 },
              })}
            ></div>
            <div
              className="tickScales sub"
              style={getStyle({
                state,
                props: { ...scaleTick, value: scaleTick.value - 0.9 },
              })}
            ></div>
          </>
        ) : null}
      </>
    );
  };

  const renderScaleLines = (scaleLine, index, total) => {
    const LineStyle = getStyle({ state, props: scaleLine });
    return (
      <div
        className="lineScales"
        style={{
          ...LineStyle,
          borderColor:
            index == 0 || index == total - 1 || index === (total - 1) / 2
              ? "red"
              : null,
        }}
      ></div>
    );
  };

  const renderCell = (cell) => {
    switch (cell.cellType) {
      case CELL_TYPE.LABEL_CELL:
        return (
          <div key={cell.cellId} className={getClassName(cell.cellType)}></div>
        );
      case CELL_TYPE.DIALYSIS_HOLDER:
        return (
          <div
            style={{ height: 86 }}
            key={cell.cellId}
            className={getClassName(cell.cellType)}
          ></div>
        );
      case CELL_TYPE.DIALYSIS_PATH:
        return (
          <div
            style={{
              height: `${state.dialysisPathHeight + state.dialysisPathPadding * 2}px`,
              margin: "20px 0",
            }}
            key={cell.cellId}
            className={getClassName(cell.cellType)}
          >
            {renderScale(
              cell.cellItems.map((item, index) =>
                renderScaleTicks(item, index, cell.cellItems.length)
              )
            )}
            <div className="lineScalesGroup">
              {cell.cellItems.map((item, index) =>
                renderScaleLines(item, index, cell.cellItems.length)
              )}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  const style = getGridTemplateRows(props.colItems.length);

  return (
    <div className={props.className} style={style}>
      {props.colItems.map(renderCell)}
    </div>
  );
}

ScaleColumn.propTypes = {
  /**
   * Component id from the notebook data file
   */
  id: PropTypes.number,
  /**
   * className to set on component
   */
  className: PropTypes.string,
  /**
   * Unique Id for column
   */
  colId: PropTypes.number,
  /**
   * Items to render in column
   */
  colItems: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * UnqiueId for the cell
       */
      cellId: PropTypes.number,
      /**
       * Type of Cell
       */
      cellType: PropTypes.oneOf([
        CELL_TYPE.LABEL_CELL,
        CELL_TYPE.DIALYSIS_HOLDER,
        CELL_TYPE.DIALYSIS_PATH,
      ]),
      /**
       * Items to be rendered inside the cell
       */
      cellItems: PropTypes.arrayOf(PropTypes.object),
      /**
       * label for the cell [only for LABEL_CELL, EMPTY_DIALYSISL_HOLDER ]
       */
      label: PropTypes.string,
    })
  ),
  /**
   * AriaLabel of the heading
   */
  headingAriaLabel: PropTypes.shape({
    /**
     * Unique key for the data
     */
    key: PropTypes.number,
    /**
     * Label of the Heading
     */
    label: PropTypes.string,
    /**
     * Arialabel to display on the heading
     */
    ariaLabel: PropTypes.string,
  }),
};

ScaleColumn.defaultProps = {};
